const liberWhite = {
    400: '#F8F8F8',
    300: '#F3F3F3',
    200: '#E5E5E7',
    100: '#DDDDDF',
};
export default liberWhite;
